<template>
  <div>
    <v-alert
      v-if="show_alert"
        border="left"
        colored-border
        color="primary"
        elevation="2"
        type="info"
        dismissible
    >
      <div class="d-flex align-start">
        <div>
          <div class="text-subtitle-1 font-weight-bold mb-2">
            CRM Integration Required
          </div>
          <div class="text-body-2">
            {{ feature_name }} requires a supported CRM integration to function properly. It does not appear your
            account is configured with a compatible CRM integration.
            <a
              @click="showIntegrationsDialog"
              class="text-decoration-underline"
              style="cursor: pointer;"
            >
              View supported integrations
            </a>
            to see which CRM systems are compatible with this feature.
          </div>
        </div>
      </div>
    </v-alert>

    <!-- Supported Integrations Dialog -->
    <v-dialog
      v-model="show_integrations_dialog"
      max-width="600"
    >
      <v-card>
        <v-card-title>
          Supported Integrations for {{ feature_name }}
        </v-card-title>
        <v-card-text>
          <p>
            The following CRM integrations support the {{ feature_name }} feature:
          </p>
          <ul
            v-if="supported_integrations.length > 0"
            class="mt-3"
          >
            <li
              v-for="integration in supported_integrations"
              :key="integration.value"
            >
              {{ integration.text }}
            </li>
          </ul>
          <p
            v-else
            class="mt-3 text--secondary"
          >
            No supported integrations found.
          </p>
          <p class="mt-4 text--secondary">
            If you need help setting up an integration, please contact RedChirp support.
          </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="primary darken-1"
            text
            @click="show_integrations_dialog = false"
          >
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'AlertIntegrationRequired',

  props: {
    feature_identifier: {
      type: String,
      required: true,
    },
    feature_name: {
      type: String,
      default: 'This feature',
    },
  },

  data() {
    return {
      has_integration: null,
      show_integrations_dialog: false,
      supported_integrations: [],
    };
  },

  mounted() {
    this.checkIntegrationAvailability();
    this.loadSupportedIntegrations();
  },

  computed: {
    show_alert() {
      return this.has_integration === false;
    },
  },

  methods: {
    checkIntegrationAvailability() {
      this.$rc.hasEnabledIntegrationFeature(
        this.feature_identifier,
        is_supported => {
          this.has_integration = is_supported;
          this.$emit('integration-status-changed', this.has_integration);
        },
        () => {
          this.has_integration = false;
          this.$emit('integration-status-changed', this.has_integration);
        }
      );
    },

    loadSupportedIntegrations() {
      this.$rc.getIntegrationsForFeature(
        this.feature_identifier,
        supporting_integrations => {
          this.supported_integrations = supporting_integrations.map(integration => ({
            text: integration.text,
            value: integration.value,
          }));
        },
        () => {
          this.supported_integrations = [];
        }
      );
    },

    showIntegrationsDialog() {
      this.show_integrations_dialog = true;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>

